import React from 'react';
import { TbChecks } from "react-icons/tb";
import { formatNameForAvatar } from '_utils/functions';
import UserCircleInitials from './user-circle-initials';

export const getHoursAndMinutes = (date) => {
    let jsDate;

    if (typeof date === 'string') {
        jsDate = new Date(date);
    } else if (date && 'seconds' in date) {
        jsDate = new Date(date.seconds * 1000 + Math.floor(date.nanoseconds / 1000000));
    } else if (date && '_seconds' in date) {
        jsDate = new Date(date._seconds * 1000 + Math.floor(date._nanoseconds / 1000000));

    } else if (date instanceof Date) {
        jsDate = date;
    } else {
        jsDate = new Date();
    }

    const hour = jsDate.getHours();
    const minute = jsDate.getMinutes();

    return `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;
};

const Message = ({ msg, emp }) => {
    return <div style={{
        display: 'flex',
        marginBottom: "20px",
        alignItems: 'flex-end',
        justifyContent: msg?.senderId === emp?.employeeId ? 'flex-end' : 'flex-start'
    }}>
        {msg?.senderId !== emp?.employeeId &&
            <div style={{ marginInlineEnd: "8px" }}>
                <UserCircleInitials
                    initials={formatNameForAvatar(msg?.senderName)}
                    size={32}
                    fontSize={14}
                />
            </div>
        }
        <div style={{
            maxWidth: '70%',
            minWidth: '200px',
            padding: 10,
            borderRadius: 16,
            backgroundColor: msg?.senderId === emp?.employeeId ? "#007bff" : "lightgray",
            color: msg?.senderId === emp?.employeeId ? "white" : "black",
            borderBottomRightRadius: msg?.senderId === emp?.employeeId ? 2 : 16,
            borderBottomLeftRadius: msg?.senderId === emp?.employeeId ? 16 : 2,

        }}>
            <p style={{ margin: 0, width: "fit-content" }}>{msg?.text ?? ""} </p>
            <div style={{ display: "flex", alignItems: "center", justifyContent: 'flex-end', gap: 5, }}>
                <p style={{ margin: 0, width: "fit-content", fontSize: '12px', color: msg?.senderId === emp?.employeeId ? 'white' : '#666' }}>{getHoursAndMinutes(msg?.sentAt ?? "")} </p>
                {msg?.senderId !== emp?.employeeId && <TbChecks color={msg?.status === "seen" ? "green" : "gray"} />}
            </div>
        </div>
        {msg?.senderId === emp?.employeeId &&
            <div style={{ marginInlineStart: "8px" }}>
                <UserCircleInitials
                    initials={formatNameForAvatar(msg?.senderName)}
                    size={32}
                    fontSize={14}
                />
            </div>
        }

    </div>
}

export default Message;